import { IAISuggestion, IAssignment, IQuestionAnswer } from '@/components/staffer/Grading/types';
import { normalizedScore } from '@/components/staffer/Grading/utils';

const POLL_INTERVAL_MS = 5000;

export const REVIEWABLE_STATES: IAISuggestion['state'][] = [
  'generating', 'ai_suggested_pending', 'ai_accepted_as_is', 'ai_edited', 'ai_rejected',
];

const isGenerating = (qa: IQuestionAnswer) => qa.ai_suggestion?.state === 'generating';

export const generatingSuggestionAnswers = (questionAnswers?: IQuestionAnswer[]) => (
  (questionAnswers || []).filter(isGenerating)
);

export const pollWhileGenerating = (response?: { data?: IQuestionAnswer[] }) => (
  response?.data?.some(isGenerating) ? POLL_INTERVAL_MS : false
);

// AIDEV-NOTE: holds every suggestion back while any are still generating so the banner, stripes and
// chips land together — a card that grew its chip mid-batch would jolt the page under the teacher.
export const pendingSuggestionAnswers = (questionAnswers?: IQuestionAnswer[]) => {
  if (!questionAnswers || questionAnswers.some(isGenerating)) return [];

  return questionAnswers.filter(qa => qa.ai_suggestion?.state === 'ai_suggested_pending');
};

export const displayedSuggestedScore = (
  assignment: Pick<IAssignment, 'normalization_factor'>,
  score: string,
) => normalizedScore(assignment, parseFloat(score)).toFixed(1);
